// App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import Layout from "./components/Layout";

// paginile tale
import Home from "./pages/Home";
import DespreMine from "./pages/DespreMine";
import Servicii from "./pages/Servicii";
import Membership from "./pages/Membership";
import Resurse from "./pages/Resurse";
import Marturii from "./pages/Marturii";
import Contact from "./pages/Contact";
import Termeni from "./pages/Termeni";

// detectăm lățimea ecranului
function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1024);
    handleResize(); // inițial
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
}

function App() {
  const isMobile = useIsMobile();

  return (
    <ThemeProvider>
      <Router>
        <Layout>
          {isMobile ? (
            <div className="space-y-16">
              <Home />
              <DespreMine />
              <Servicii />
              <Membership />
              <Resurse />
              <Marturii />
              <Contact />
              <Termeni />
            </div>
          ) : (
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/despre" element={<DespreMine />} />
              <Route path="/servicii" element={<Servicii />} />
              <Route path="/membership" element={<Membership />} />
              <Route path="/resurse" element={<Resurse />} />
              <Route path="/marturii" element={<Marturii />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/termeni" element={<Termeni />} />
            </Routes>
          )}
        </Layout>
      </Router>
    </ThemeProvider>
  );
}

export default App;
